module.exports = __webpack_public_path__ + "img/ico-user.b88fee9e.svg";